export default "__VITE_ASSET__C0osv2ew__"